import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

// 本语句作用是扫描指定目录下所有符合条件的文件
// 函数的三个入参分别是
// 1.要扫描的路径
// 2.是否递归扫描：true递归扫描，扫描指定文件夹下的所有子文件夹；false只扫描指定路径
// 3.正则表达式，/\.router\.js$/表示匹配以.router.js为结尾的文件
// 这里，正则表达式一定要和自己的路由信息配置文件的命名相符合，不然扫描不到
const modulesFiles = require.context("../", true, /\.router\.js$/);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/header",
    name: "Header",
    component: () => import("@/components/Header/index"),
  },
  {
    path: "/enterprise",
    name: "Enterprise",
    component: () => import("../views/enterprise/Enterprise"), //单位列表
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/detail",
    name: "Detail",
    meta: { keepAlive: true },
    component: () => import("../views/enterprise/Detail"), //单位详情
  },
  {
    path: "/operator",
    name: "Operator",
    component: () => import("../views/enterprise/Operator"), //单位新增
  },
  {
    path: "/article",
    name: "Article",
    component: () => import("../views/project/Article"), //项目列表
  },
  {
    path: "/addproject",
    name: "Project",
    component: () => import("../views/project/AddProject"), //项目新增
  },
  {
    path: "/projectdetail",
    name: "ProjectDetail",
    component: () => import("../views/project/ProjectDetail"), //项目详情
  },
  {
    path: "/facility",
    name: "Facility",
    component: () => import("../views/facility/Facility"), //设备列表
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/facilitydetail",
    name: "FacilityDetail",
    component: () => import("../views/facility/FacilityDetail"), //设备列表
  },
  {
    path: "/addfacility",
    name: "Addfacility",
    component: () => import("../views/facility/AddFacility"), //设备新增
  },
  {
    path: "/detection",
    name: "Detection",
    component: () => import("../views/detevtion/Detection"), // 检验检测
    meta: {
      keepAlive: true,
    },
  },

  // 检验检测发布
  {
    path: "/instrument",
    name: "Instrument",
    component: () => import("../views/instrument/Instrument"),
  },
  {
    path: "/jobcontent",
    name: "Jobcontent",
    component: () => import("@/components/jobContent/JobContent"),
  },
  {
    path: "/SubmitRequest",
    name: "SubmitRequest",
    component: () => import("@/views/SubmitRequest/SubmitRequest"),
  },
  {
    path: "/uploadimg",
    name: "UploadImg",
    component: () => import("@/views/UploadImg/index"),
  },

  // 手写签名
  {
    path: "/signature",
    name: "Signature",
    component: () => import("@/views/signature/index"),
  },
  //工程名称
  {
    path: "/projectname",
    name: "projectname",
    component: () => import("@/views/project/projectname"),
  },
  //委托单位
  {
    path: "/projectclient",
    name: "projectclient",
    component: () => import("@/views/project/projectclient"),
  },
  {
    //下一步确认
    path: "/Nextconfirmation",
    name: "Nextconfirmation",
    component: () => import("@/views/Nextconfirmation/Nextconfirmation"),
  },
  // 选择人员
  {
    path: "/auditor",
    name: "Auditor",
    component: () => import("@/views/Nextconfirmation/Auditor"),
  },
  {
    //检验检测发布设备概况设备类别选择
    path: "/EquipmentCategoryName",
    name: "EquipmentCategoryName",
    component: () => import("@/views/Nextconfirmation/EquipmentCategoryName"),
  },
  {
    //记录详情只读
    path: "/RecordDetailsOnly",
    name: "RecordDetailsOnly",
    component: () => import("@/views/RecordDetailsOnly/RecordDetailsOnly"),
  },
  {
    //记录详情只读 查看审核
    path: "/ReadOnly",
    name: "ReadOnly",
    component: () => import("@/views/RecordDetailsOnly/ReadOnly"),
  },
  //历史记录HistoryList
  {
    //记录详情只读 查看审核
    path: "/HistoryList",
    name: "HistoryList",
    component: () => import("@/views/RecordDetailsOnly/HistoryList"),
  },

  // 记录审核
  {
    path: "/examine",
    name: "Examine",
    component: () => import("@/views/detevtion/Examine"),
  },
  //二次审核
  {
    path: "/examinetwo",
    name: "ExamineTwo",
    component: () => import("@/views/detevtion/ExamineTwo"),
  },
  {
    path: "/examineInspector",
    name: "ExamineInspector",
    component: () => import("@/views/detevtion/ExamineInspector"),
  },
  //签发
  {
    path: "/issue",
    name: "Issue",
    component: () => import("@/views/detevtion/Issue"),
  },
  //历史记录
  {
    path: "/history",
    name: "History",
    component: () => import("@/views/detevtion/History"),
  },

  // 单位 设备 项目 下拉页面跳转  select
  {
    path: "/selectUnit",
    name: "SelectUnit",
    component: () => import("@/components/select/selectUnit.vue"),
  },

  {
    path: "/selectPrj",
    name: "SelectPrj",
    component: () => import("@/components/select/selectPrj.vue"),
  },
  {
    path: "/reviewOfTheRefusal",
    name: "reviewOfTheRefusal",
    component: () =>
      import("@/views/reviewOfTheRefusal/reviewOfTheRefusal.vue"),
  },

  {
    path: "/draftDetai",
    name: "draftDetai",
    component: () => import("@/views/draftDetai/draftDetai.vue"),
  },
  {
    path: "/draftSubmit",
    name: "draftSubmit",
    component: () => import("@/views/draftDetai/draftSubmit.vue"),
  },
  // 生成文档
  {
    path: "/generateDocument",
    name: "GenerateDocument",
    component: () => import("@/components/Documents/GenerateDocument.vue"),
  },
  // 文件下载
  {
    path: "/fileDownload",
    name: "FileDownload",
    component: () => import("@/components/Documents/FileDownload.vue"),
  },
  {
    //委托单位搜索
    path: "/projectNamesearch",
    name: "projectNamesearch",
    component: () => import("@/views/project/projectNamesearch.vue"),
  },
  {
    //工程名称搜索
    path: "/projectclientSearch",
    name: "projectclientSearch",
    component: () => import("@/views/project/projectclientSearch.vue"),
  },

  /*
   * 检验检测复检
   * */

  // 复检发布页
  {
    path: "/PublishHome",
    name: "PublishHome",
    component: () =>
      import("@/views/Reinspection/RecheckPublish/PublishHome.vue"),
    children: [
      {
        path: "/RepeDynamicMessage",
        name: "RepeDynamicMessage",
        component: () =>
          import(
            "@/views/Reinspection/RecheckPublish/RepetitionCheckout/RepeDynamicMessage.vue"
          ),
        meta: {
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: "/RecheckDistribute",
    name: "RecheckDistribute",
    component: () =>
      import("@/views/Reinspection/recheckDistribute/RecheckDistribute.vue"),
  },
  //复检只读页
  {
    path: "/RecheckReleasePreview",
    name: "RecheckReleasePreview",
    component: () =>
      import("@/views/Reinspection/RecheckPreview/RecheckReleasePreview.vue"),
  },

  // 复检 -- 发布
  {
    path: "/PublishingNode",
    name: "PublishingNode",
    component: () =>
      import("@/views/Reinspection/CirculationNodes/PublishingNode.vue"),
  },
  // 复检 -- 审核
  {
    path: "/AuditNode",
    name: "AuditNode",
    component: () =>
      import("@/views/Reinspection/CirculationNodes/AuditNode.vue"),
  },
  // 复检 -- 签发
  {
    path: "/IssuingNode",
    name: "IssuingNode",
    component: () =>
      import("@/views/Reinspection/CirculationNodes/IssuingNode.vue"),
  },

  {
    path: "/recallApplay",
    name: "recallApplay",
    component: () => import("@/views/detevtion/recall/recallApply.vue"),
  },
  {
    path: "/selectRecallPerson",
    name: "selectRecallPerson",
    component: () => import("@/views/detevtion/recall/selectRecallPerson.vue"),
  },
  {
    path: "/recallDraft",
    name: "recallDraft",
    component: () => import("@/views/detevtion/recall/recallDraft.vue"),
  },
  {
    path: "/recallAuthorize",
    name: "recallAuthorize",
    component: () => import("@/views/detevtion/recall/recallAuthorize.vue"),
  },
  {
    path: "/recallApprove",
    name: "recallApprove",
    component: () => import("@/views/detevtion/recall/recallApprove.vue"),
  },
  // 印章申请 - 首页
  {
    path: "/sealApply",
    name: "index",
    component: () => import("@/views/seal-apply/index"),
    meta: {
      keepAlive: true,
    },
  },
  // 印章申请 - 草稿页
  {
    path: "/sealDraft",
    name: "draft",
    component: () => import("@/views/seal-apply/draft"),
    meta: {
      keepAlive: true,
    },
  },
  // 印章申请 - 申请页
  {
    path: "/applyFor",
    name: "applyFor",
    component: () => import("@/views/seal-apply/apply-for"),
    meta: {
      keepAlive: true,
    },
  },
  // 印章申请 - 任务处理
  {
    path: "/taskHandle",
    name: "taskHandle",
    component: () => import("@/views/seal-apply/task-handle"),
    meta: {
      keepAlive: true,
    },
  },
  // 印章申请 - 详情
  {
    path: "/sealDetail",
    name: "sealDetail",
    component: () => import("@/views/seal-apply/detail"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/selectPerson",
    name: "selectPerson",
    component: () => import("@/views/seal-apply/selectPerson.vue"),
  },
  // 工作任务 - 首页
  {
    path: "/workTask",
    name: "workTask",
    component: () => import("@/views/worktask/index"),
    meta: {
      keepAlive: true,
    },
  },
  // 工作任务 - 新增
  {
    path: "/addWorkTask",
    name: "addWorkTask",
    component: () => import("@/views/worktask/add"),
    meta: {
      keepAlive: true,
    },
  },
  // 工作任务 - 接受
  {
    path: "/acceptWorkTask",
    name: "acceptWorkTask",
    component: () => import("@/views/worktask/accept"),
    meta: {
      keepAlive: true,
    },
  },
  // 工作任务 - 完成
  {
    path: "/todoWorkTask",
    name: "todoWorkTask",
    component: () => import("@/views/worktask/todoTask"),
    meta: {
      keepAlive: true,
    },
  },
  // 工作任务 - 草稿
  {
    path: "/workTaskDraft",
    name: "workTaskDraft",
    component: () => import("@/views/worktask/draft"),
    meta: {
      keepAlive: true,
    },
  },
  // 工作任务 - 处理详情
  {
    path: "/workTaskAcceptDetail",
    name: "workTaskAcceptDetail",
    component: () => import("@/views/worktask/acceptDetail"),
    meta: {
      keepAlive: true,
    },
  },

  // 工作任务 - 详情
  {
    path: "/workTaskDetail",
    name: "workTaskDetail",
    component: () => import("@/views/worktask/detail"),
    meta: {
      keepAlive: true,
    },
  },

  // 工作任务 - 人员列表详情
  {
    path: "/workTaskPersonHandle",
    name: "workTaskPersonHandle",
    component: () => import("@/views/worktask/personhandle"),
    meta: {
      // keepAlive: true
    },
  },
  // 工作任务 - 拒绝处理
  {
    path: "/workTaskRejectHandle",
    name: "workTaskRejectHandle",
    component: () => import("@/views/worktask/rejectHandle"),
    meta: {
      keepAlive: true,
    },
  },
  // 报告推送服务定价页面
  {
    path: "/reportPush/servicePricing",
    name: "ReportPushServicePricing",
    component: () => import("@/views/inspection/reportPush/servicePricing"),
  },
  // 报告推送PDF查看器
  {
    path: "/reportPush/pdfViewer",
    name: "ReportPushPdfViewer",
    component: () => import("@/views/inspection/reportPush/pdfViewer"),
  },
  // 权限管理
  {
    path: "/PermissionManagement",
    name: "PermissionManagement",
    component: () => import("@/views/PermissionManagement/index"),
    meta: {
      keepAlive: true,
    },
  },
  // 业务规则新增
  {
    path: "/BusinessRuleAdd",
    name: "BusinessRuleAdd",
    component: () => import("@/views/PermissionManagement/businessRuleAdd"),
    meta: {
      keepAlive: true,
    },
  },
  // 项目权限配置
  {
    path: "/ProjectPermission/:id/:mode?",
    name: "ProjectPermission",
    component: () => import("@/views/PermissionManagement/projectPermission"),
    meta: {
      keepAlive: true,
    },
  },
  // 权限筛选
  {
    path: "/PermissionFilter",
    name: "PermissionFilter",
    component: () => import("@/views/PermissionManagement/UnifiedFilter"),
    meta: {
      keepAlive: true,
    },
  },
  // 业务规则筛选
  {
    path: "/BusinessRuleFilter",
    name: "BusinessRuleFilter",
    component: () => import("@/views/PermissionManagement/UnifiedFilter"),
    meta: {
      keepAlive: true,
    },
  },
  // 人员角色选择
  {
    path: "/PersonnelRoleSelection/:id/:mode?",
    name: "PersonnelRoleSelection",
    component: () =>
      import("@/views/PermissionManagement/personnelRoleSelection"),
    meta: {
      keepAlive: true,
    },
  },
  // 人员角色配置
  {
    path: "/PersonnelRole/:id/:roleId/:mode?",
    name: "PersonnelRole",
    component: () => import("@/views/PermissionManagement/personnelRole"),
    meta: {
      keepAlive: true,
    },
  },
  // 人员角色查看
  {
    path: "/PersonnelRoleView/:id",
    name: "PersonnelRoleView",
    component: () =>
      import("@/views/PermissionManagement/PersonnelRoleView.vue"),
    meta: {
      keepAlive: true,
    },
  },
  // 已添加项目筛选 - 统一筛选组件
  {
    path: "/AddedProjectFilter/:id",
    name: "AddedProjectFilter",
    component: () => import("@/views/PermissionManagement/UnifiedFilter"),
    meta: {
      keepAlive: true,
    },
  },
  // 未添加项目筛选 - 统一筛选组件
  {
    path: "/PendingProjectFilter/:id",
    name: "PendingProjectFilter",
    component: () => import("@/views/PermissionManagement/UnifiedFilter"),
    meta: {
      keepAlive: true,
    },
  },
  // 已添加人员筛选 - 统一筛选组件
  {
    path: "/AddedPersonnelFilter/:id",
    name: "AddedPersonnelFilter",
    component: () => import("@/views/PermissionManagement/UnifiedFilter"),
    meta: {
      keepAlive: true,
    },
  },
  // 未添加人员筛选 - 统一筛选组件
  {
    path: "/PendingPersonnelFilter/:id",
    name: "PendingPersonnelFilter",
    component: () => import("@/views/PermissionManagement/UnifiedFilter"),
    meta: {
      keepAlive: true,
    },
  },
  // 执行标准配置
  {
    path: "/ExecuteStandard/:id/:mode?",
    name: "ExecuteStandard",
    component: () => import("@/views/PermissionManagement/executeStandard"),
    meta: {
      keepAlive: true,
    },
  },
  // 已配置标准筛选 - 统一筛选组件
  {
    path: "/ConfiguredStandardFilter/:id",
    name: "ConfiguredStandardFilter",
    component: () => import("@/views/PermissionManagement/UnifiedFilter"),
    meta: {
      keepAlive: true,
    },
  },
  // 未配置标准筛选 - 统一筛选组件
  {
    path: "/UnconfiguredStandardFilter/:id",
    name: "UnconfiguredStandardFilter",
    component: () => import("@/views/PermissionManagement/UnifiedFilter"),
    meta: {
      keepAlive: true,
    },
  },
  // 二维码扫描
  {
    path: "/scan",
    name: "Scan",
    component: () => import("@/views/scan/index"),
  },
  // 二维码扫描预览pdf信息
  {
    path: "/scanpdf",
    name: "Scanpdf",
    component: () => import("@/views/scanpdf/index"),
    meta: {
      keepAlive: true,
    },
  },
  //pdf预览
  {
    path: "/pdfview",
    name: "Pdfview",
    component: () => import("@/views/scanpdfview/index"),
    meta: {
      keepAlive: true,
    },
  },
];

modulesFiles.keys().forEach((modulePath) => {
  const value = modulesFiles(modulePath);
  if (value.default.length > 0) {
    value.default.forEach((item) => {
      routes.push(item);
    });
  }
});

const router = new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），则返回到该位置
    if (savedPosition) {
      return savedPosition;
    }
    // 如果路由有hash锚点，则滚动到对应元素
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
    // 默认滚动到页面顶部
    return { x: 0, y: 0 };
  },
});
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

export default router;
